import React from "react";

const TipRender = ({ row }) => {
  return (
    <>
      {row.payments.map((pay, index) => (
        <p key={index} style={{ borderBottom: "1px solid #F7F9FB" }}>
          {pay?.tip?.toLocaleString()}
        </p>
      ))}
    </>
  );
};

export default TipRender;
